import { ICurrentUserState } from '@/types';
import {TYPE_TASK} from '../../../../Tasks/const';
import {TYPE_MODAL_TASK} from '../const';
import {TYPE_REPEAT_TASK} from '../../../../CreateTask/const';
import {createTask, getGroupValues, getStringValues} from '../../../helpers';

export const submitModalCreateTask = async (data: Record<string, any>, closeModal: ()=>void) => {
    const formData = new FormData();
    Object.keys(data).forEach((key: string) => {
        if (data[key]) {
            if (key === 'groups') {
                getGroupValues(data[key]).map((item) => {
                    return (
                        formData.append('groups', String(item))
                    );
                });
            } else if (key === 'repeat_dow' || key === 'repeat_day' || key === 'repeat_month') {
                formData.append(key, getStringValues(data[key]));
            } else if (key === 'remind_type' || key === 'user') {
                formData.append(key, data[key].value);
            } else if(key === 'source' && data[key].value){
                formData.append(key, data[key].value);
            } else {
                formData.append(key, data[key]);
            }
        }
    });
    try {
        await createTask(formData);
        closeModal();
    } catch (e) {
        console.error(e);
    }
};

export const initialValueCreateTaskCustomer = (user: Record<string, any> | null,type: number, order: Record<string, any>, currentUser: ICurrentUserState | null, ) => {
    return  {
        attach: null,
        title: '',
        // eslint-disable-next-line no-nested-ternary
        source: type === TYPE_MODAL_TASK.CALL_INFO ? TYPE_TASK[4] : (type === TYPE_MODAL_TASK.ORDER ? TYPE_TASK[5]: TYPE_TASK[6]),
        user: currentUser ? {value: currentUser.id} : null,
        client: user ? user.id : null,
        description:'',
        deadline_at: null,
        client_name: user ? `${user.first_name} ${user.last_name} ${user.patronymic_name || ''}` : '',
        groups: [],
        phone: user ? `+${user.phone}` : '',
        email: user ? user.email : '',
        order: type === TYPE_MODAL_TASK.ORDER ? order.id : null,
        is_repeat: false,
        repeat_by: null,
        remind_type: TYPE_REPEAT_TASK[0],
        remind_at: null,
        repeat_time_at: null,
        repeat_dow:null,
        repeat_day:null,
        repeat_month: null,
        repeat_count_remain: null,
        flagStaff: false
    }
}